import { flow, types } from 'mobx-state-tree'
import { appAuthenticateGenerate, appAuthenticateVerify } from '../../network/AppAuthenticate'
import { sendEventApi } from '../../network/sendEvent'
import { pkceGetCodeVerifier } from '../../util/utill'
import { RootStore } from '../store'

const Session = types
  .model('Session', {
    appAccessToken: types.optional(types.string, ''), //app auth AccessToken
    appRefreshToken: types.optional(types.string, ''), //app auth RefreshToken
    appAccessTokenExpiry: types.optional(types.number, -1), //app auth AccessToken expiry
    appRefreshTokenExpiry: types.optional(types.number, -1), //app auth RefreshToken expiry
    appIdToken: types.optional(types.string, ''),
    userAccessToken: types.optional(types.string, ''),
    userRefreshToken: types.optional(types.string, ''),
    userAccessTokenExpiry: types.optional(types.number, -1),
    userRefreshTokenExpiry: types.optional(types.number, -1),
    userIdentifierToken: types.optional(types.string, ''),
    CHANNEL_ID: types.optional(types.string, ''),
    deviceSessionId: types.optional(types.string, ''),
  })
  .actions((self) => ({
    appAuthenticateApi: flow(function* appAuthenticateApi() {
      try {
        const codeVerifier = pkceGetCodeVerifier(64)
        const resAppAuthGen = yield appAuthenticateGenerate(codeVerifier.toString(), RootStore.agent.CLIENT_ID, self)

        if (resAppAuthGen?.authorizationCode?.length > 0) {
          const resAppAuthVerify = yield appAuthenticateVerify(
            resAppAuthGen?.authorizationCode,
            codeVerifier.toString(),
            RootStore.agent.CLIENT_ID,
            self,
          )
          self.appAccessToken = resAppAuthVerify.appAccessToken
          self.appAccessTokenExpiry = resAppAuthVerify.appAccessTokenExpiry
          self.appRefreshToken = resAppAuthVerify.appRefreshToken
          self.appRefreshTokenExpiry = resAppAuthVerify.appRefreshTokenExpiry
          self.appIdToken = resAppAuthVerify.appIdToken
          return resAppAuthVerify
        }
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    updateUsrSessionData: flow(function* updateUsrSessionData(userSessionData: any) {
      try {
        self.userAccessToken = userSessionData.userAccessToken
        self.userAccessTokenExpiry = userSessionData.userAccessTokenExpiry
        self.userIdentifierToken = userSessionData.userIdentifierToken
        self.userRefreshToken = userSessionData.userRefreshToken
        self.userRefreshTokenExpiry = userSessionData.userRefreshTokenExpiry
        yield RootStore.agent.storeSessionData()
        return userSessionData
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    updateAppSessionData: flow(function* updateAppSessionData(appSessionData: any) {
      try {
        self.appIdToken = appSessionData.appIdToken
        self.appRefreshToken = appSessionData.appRefreshToken
        self.appAccessToken = appSessionData.appAccessToken
        self.appAccessTokenExpiry = appSessionData.appAccessTokenExpiry
        self.appRefreshTokenExpiry = appSessionData.appRefreshTokenExpiry
        yield RootStore.agent.storeSessionData()
        return appSessionData
      } catch (err) {
        RootStore.message.handleError(err)
        throw err
      }
    }),
    invalidateSession: flow(function* invalidateSession() {
      try {
        if (RootStore.consents.appType !== '0') {
          // yield invalidateUserSessionApi(self, self?.userAccessToken).catch((_) => {})
          // yield invalidateAppSessionApi(self, self?.appAccessToken)
        }
      } catch (err) {
        return err
      }
    }),
    logout: flow(function* logout() {
      self.appAccessToken = ''
      self.appRefreshToken = ''
      self.appIdToken = ''
      self.userAccessToken = ''
      self.userRefreshToken = ''
      self.userIdentifierToken = ''
      yield RootStore.agent.clearStoredSession()
      //replaceNvigation(Screens.LOAD_INITIALS)
      RootStore.message.setMessage('Session expired, Please reLogin')
    }),
    sendEventAsync: flow(function* sendEventAsync(params) {
      try {
        const response = yield sendEventApi(self, {}, params)
        return response
      } catch (err) {
        console.log(err)
      }
    }),
  }))

const sessionData = Session.create({})

export { Session, sessionData }
